import React, { Component } from 'react';
import { connect } from 'react-redux';
import { surveyActions, dashboardActions } from '../../_actions';
import { CSVLink } from "react-csv";

import FilterDMG from './FilterDMG/Filter';
import ResponseCards from './Components/ResponseCards';
import ResponseMetaTable from './Components/ResponseMetaTable';

import moment from 'moment';

import Header from './Header/Header';
import LoadingOverlay from 'react-loading-overlay';



// import MultiBarStaticChart from './Charts/MultiBarStaticChart';


class SurveyReport extends Component {
    constructor(props) {
        super(props);
        this.state = {

            FilterValues: [],
            showFilter: false,
            showValue: '',

            litsXAxis: '',



            selectFilterType: 1,
            surveyReportEmail: '',
            openModalComfirmSend: false,
            SaveEmployeeId: '',
            DemographValue: '',



            filterList: [
                {
                    id: true,
                    type: 'Show All'
                },
                {
                    id: false,
                    type: 'Show Filter'
                }
            ],


            isMailList: [
                {
                    id: 0,
                    type: 'Deliver Status'
                },
                {
                    id: 1,
                    type: 'Delivered'
                },
                {
                    id: 2,
                    type: 'Not Delivered'
                }
            ],

            isClickedList:
                [
                    {
                        id: 0,
                        type: 'Click Status'
                    },
                    {
                        id: 1,
                        type: 'Clicked',
                    },
                    {
                        id: 2,
                        type: 'Not Clicked'
                    }
                ],

            isCompleteList: [
                {
                    id: 0,
                    type: 'Complete Status'
                },
                {
                    id: 1,
                    type: 'Completed'
                },
                {
                    id: 2,
                    type: 'Not Completed'
                }
            ],

            filterformData: {
                "showAll": true,
                "isMailSent": 0,
                "isClicked": 0,
                "isComplete": 0
            },


            currFilterName: "Demographic",

            CurrentSurveyCode: this.props.match.params.id,


            campaignEmpPageNo: 1,
            campaignEmpSize: 100,
            resAnalyticPageNo: 1,
            handleOpenCodeModal: false,
            responseType: 1



        }
    }
    componentDidMount() {
        let data2 = {
            "surveyCode": this.state.CurrentSurveyCode
        }

        this.props.dispatch(dashboardActions.getEmpSurveyWiseFilter(data2));
        this.props.dispatch(surveyActions.getIndexByFilterDMG({
            filters: []
        }));

        this.props.dispatch(dashboardActions.getClientProfile(data2));
        this.props.dispatch(dashboardActions.getMetaRespondantDetails(data2));
        // this.props.dispatch(dashboardActions.getSurveyResponseList(data2));


        let dataX1 = {
            "surveyCode": this.state.CurrentSurveyCode,
            pageNo: this.state.campaignEmpPageNo,
            size: this.state.campaignEmpSize
        }

        this.props.dispatch(surveyActions.getResponseAnalyticsPagination(dataX1));


        

    }


    closeFilter = (check1, check2) => {
        this.setState({ showFilter: check1, showValue: check2 });
    }


    handleCreateSurveyPopup = () => {

    }

    handleSetFilter = (value) => {

        let { filterformData } = this.state;

        if (value === 'true' || value === true) {
            this.setState({ selectFilterType: 1 });
            filterformData['showAll'] = true;
        }
        else {
            this.setState({ selectFilterType: 2 });
            filterformData['showAll'] = false;
        }

        this.setState({ filterformData });

    }


    handleIsMailSent = (value) => {
        let { filterformData } = this.state;
        if (value === 'true' || value === true) {
            filterformData['isMailSent'] = true;
        }
        else {
            filterformData['isMailSent'] = false;

        }
        this.setState({ filterformData });

    }

    handleIsClicked = (value) => {
        let { filterformData } = this.state;
        if (value === 'true' || value === true) {
            filterformData['isClicked'] = true;
        }
        else {
            filterformData['isClicked'] = false;

        }
        this.setState({ filterformData });

    }

    handleIsComplete = (value) => {
        let { filterformData } = this.state;
        if (value === 'true' || value === true) {
            filterformData['isComplete'] = true;
        }
        else {
            filterformData['isComplete'] = false;

        }
        this.setState({ filterformData });

    }

    handleEmailInput = (val) => {
        this.setState({ surveyReportEmail: val });
    }

    HandleFilterType = (value) => {
        this.setState({ selectFilterType: value });
    }




    forceMail = (id) => {
        this.setState({
            openModalComfirmSend: true,
            SaveEmployeeId: id
        })
    }


    handleSendSingleMail = () => {
        let { SaveEmployeeId } = this.state;
        // this.props.dispatch(surveyActions.resendCampain({ id: SaveEmployeeId }));
        this.setState({ SaveEmployeeId: '' });
    }

    resendCampain = (id) => {
        this.setState({
            openModalComfirmSend: true,
            SaveEmployeeId: id
        })
    }

    handleConfirmMailClose = () => {
        this.setState({ openModalComfirmSend: false, SaveEmployeeId: '' });
    }


    handleQuestionFilterName = (Name, Value) => {
        this.setState({ DemographValue: '' });

        let data = {
            "surveyCode": this.state.CurrentSurveyCode,
            "xAxis": Name
        }
        // this.props.dispatch(dashboardActions.getResponseAnalytics(data));
    }

    handleQuestionFilterValue = (Name, Value) => {
        console.log('Value:', Value)
        if (Value === 'All') {
            this.setState({ DemographValue: '' });
        }
        else {
            this.setState({ DemographValue: Value });
        }
    }

    handleQuestionFilterValueSave = () => {

    }

    handleQuestionFilterNameSave = () => {

    }



    handlePaginaton = (type, total) => {
        let { campaignEmpPageNo } = this.state;
        let PageNo = 1;
        if (type === "prev") {
            if (campaignEmpPageNo > 1) {
                PageNo = campaignEmpPageNo - 1;
            }
        }
        else if (type === "next" && total > 100) {
            PageNo = campaignEmpPageNo + 1;
        }

        this.setState({ campaignEmpPageNo: PageNo }, () => {
            let dataX1 = {
                "surveyCode": this.state.CurrentSurveyCode,
                pageNo: this.state.campaignEmpPageNo,
                size: this.state.campaignEmpSize
            }
            this.props.dispatch(surveyActions.getResponseAnalyticsPagination(dataX1));
        });

    }


    handleResponseType = (value) => {
        if (value === 2) {

            let { dashboard } = this.props;
            let { EmpFilterData } = dashboard;

            let CurrentFilterName = "";
            if (EmpFilterData && EmpFilterData.length > 0) {
                CurrentFilterName = EmpFilterData[0]["name"]
            }
            console.log("CurrentFilterName------------>", CurrentFilterName)

            let data = {
                "surveyCode": this.state.CurrentSurveyCode,
                "xAxis": CurrentFilterName
            }
            this.props.dispatch(dashboardActions.getMetaResponseAnalyticsFilter(data));
        }
        this.setState({ responseType: value });
    }


    RefreshAPI = () => {

        let dataX1 = {
            surveyCode: this.state.CurrentSurveyCode,
            pageNo: this.state.campaignEmpPageNo,
            size: this.state.campaignEmpSize
        }
        this.props.dispatch(surveyActions.getResponseAnalyticsPagination(dataX1));
    }

    RefreshDMG = () => {
        let { dashboard } = this.props;
        let { EmpFilterData } = dashboard;

        let CurrentFilterName = "";
        if (EmpFilterData && EmpFilterData.length > 0) {
            CurrentFilterName = EmpFilterData[0]["name"]
        }
        console.log("CurrentFilterName------------>", CurrentFilterName)

        let data = {
            "surveyCode": this.state.CurrentSurveyCode,
            "xAxis": CurrentFilterName
        }
        this.props.dispatch(dashboardActions.getMetaResponseAnalyticsFilter(data));
    }


    handleMultifilterIndexScore2 = (finalFilter, name) => {
        this.setState({ FilterValues: finalFilter, currFilterName: name });
        let FilterValues = finalFilter;
        let XAxis = "";
        let Filters = [];
        if (FilterValues && FilterValues.length > 0) {
            let getIndex = FilterValues.findIndex(prev => prev.value === "All");
            if (getIndex !== -1) {
                XAxis = FilterValues[getIndex].level;
                FilterValues.forEach((item) => {
                    if (item.value !== "All") {
                        Filters.push(item);
                    }
                });
            }
            else {
                XAxis = FilterValues[FilterValues.length - 1].level;
                Filters = FilterValues;
            }
        }

        let { dashboard } = this.props;
        let { EmpFilterData } = dashboard;

        let dataX = {
            "surveyCode": this.state.CurrentSurveyCode,
            "xAxis": XAxis
        }
        this.props.dispatch(dashboardActions.getMetaResponseAnalyticsFilter(dataX));
        this.setState({ litsXAxis: XAxis });
    }






    handleExportModal = (check) => {
        this.setState({ showExportModal: check })
    }




    render() {
        let { survey, dashboard,
            currFilterName,
            getRespondantDetailsData,
            styleType,
            handleGoBack

        } = this.props;
        let { EmpFilterData, getSurveyResponseListData, getResponseAnalyticsData, getMetaRespondantDetailsData, getMetaResponseAnalyticsFilterData, getCompanyNameOnlyData } = dashboard;
        let { getResponseAnalyticsPaginationData, getResponseAnalyticsPaginationTotal, getIndexByFilterDMGData } = survey;

        let { responseType, surveyReportEmail, selectFilterType, filterformData, openModalComfirmSend, DemographValue, FilterValues } = this.state;


        let DemographicResponseNewData = getResponseAnalyticsData;

        let loading = (survey.loading || dashboard.loading);


        function ResponseRate(item) {
            return (item.completed * 100) / item.totalInvite
        }


        if (DemographicResponseNewData && DemographicResponseNewData.length > 0) {
            DemographicResponseNewData.sort((a, b) => ResponseRate(b) - ResponseRate(a));
        }

        let FilterLevelData = [];
        let filterLevels = EmpFilterData;
        if (filterLevels && filterLevels.length > 0) {
            filterLevels.forEach((item) => {
                if (item.name !== "ManagerPID") { FilterLevelData.push(item); }
            })
        }


        let DemographicValueList = []
        if (DemographicResponseNewData && DemographicResponseNewData.length > 0) {
            DemographicResponseNewData.forEach((value, index) => {
                DemographicValueList.push(value.name);
            });
        }

        function spliceDecimal(no) {
            if (no) {
                let str = no.toString();
                let first = str.split('.')[0];
                let second = str.split('.')[1];
                let second2 = second ? second.substring(0, 2) : ""
                let final = first + '.' + second2;
                if (second2) {
                    return parseFloat(final).toFixed(2)
                } else {
                    return no
                }
            } else {
                return 0
            }
        }


        function getResponseOverall(data, type) {
            let value = 0;
            let mailSent = data["mailSent"] ? data["mailSent"] : 0
            let clicked = data["clicked"] ? data["clicked"] : 0
            let completed = data["completed"] ? data["completed"] : 0

            if (type === "mailSent") {
                value = mailSent
            } else if (type === "clicked") {
                value = clicked
            } else if (type === "notclicked") {
                value = mailSent - clicked
            } else if (type === "completed") {
                value = completed
            } else if (type === "notcompleted") {
                value = mailSent - completed
            } else if (type === "responserate") {
                let perc = spliceDecimal((completed * 100) / mailSent);
                console.log("perc", perc)
                value = perc
            }
            if (type === "responserate") {
                console.log("value--->", value)
            }
            return value

        }


        function spliceDecimal(no) {
            if (no) {
                let str = no.toString();
                let first = str.split('.')[0];
                let second = str.split('.')[1];
                let second2 = second ? second.substring(0, 2) : ""
                let final = first + '.' + second2;
                if (second2) {
                    return parseFloat(final).toFixed(2)
                } else {
                    return no
                }
            } else {
                return 0
            }
        }


        function getResponseOverall(data, type) {
            let value = 0;
            let mailSent = data["mailSent"] ? data["mailSent"] : 0
            let clicked = data["clicked"] ? data["clicked"] : 0
            let completed = data["completed"] ? data["completed"] : 0

            if (type === "mailSent") {
                value = mailSent
            } else if (type === "clicked") {
                value = clicked
            } else if (type === "notclicked") {
                value = mailSent - clicked
            } else if (type === "completed") {
                value = completed
            } else if (type === "notcompleted") {
                value = mailSent - completed
            } else if (type === "responserate") {
                let perc = spliceDecimal((completed * 100) / mailSent);
                console.log("perc", perc)
                value = perc
            }
            if (type === "responserate") {
                console.log("value--->", value)
            }
            return value

        }





        function getResponseValue(data, type) {
            let value = 0;
            let mailSent = data["mailSent"] ? data["mailSent"] : 0
            let clicked = data["clicked"] ? data["clicked"] : 0
            let completed = data["completed"] ? data["completed"] : 0

            if (type === "mailSent") {
                value = mailSent
            } else if (type === "clicked") {
                value = clicked
            } else if (type === "notclicked") {
                value = mailSent - clicked
            } else if (type === "completed") {
                value = completed
            } else if (type === "notcompleted") {
                value = mailSent - completed
            } else if (type === "responserate") {
                let perc = spliceDecimal((Number(completed) * 100) / Number(mailSent));
                console.log("perc", perc)
                value = perc
            }
            if (type === "responserate") {
                console.log("value--->", value)
            }
            return value

        }




        let CurrentFilterName = "";
        if (this.state.litsXAxis) {
            CurrentFilterName = this.state.litsXAxis;
        } else {
            if (FilterLevelData && FilterLevelData.length > 0) {
                CurrentFilterName = FilterLevelData[0]["name"]
            }
        }

        let temp1 = {}

        temp1[CurrentFilterName] = "Overall";
        temp1["Sent"] = getResponseOverall(getMetaRespondantDetailsData && getMetaRespondantDetailsData[0] ? getMetaRespondantDetailsData[0] : {}, "mailSent");
        temp1["Clicked"] = getResponseOverall(getMetaRespondantDetailsData && getMetaRespondantDetailsData[0] ? getMetaRespondantDetailsData[0] : {}, "clicked");
        temp1["Notclicked"] = getResponseOverall(getMetaRespondantDetailsData && getMetaRespondantDetailsData[0] ? getMetaRespondantDetailsData[0] : {}, "notclicked");
        temp1["Completed"] = getResponseOverall(getMetaRespondantDetailsData && getMetaRespondantDetailsData[0] ? getMetaRespondantDetailsData[0] : {}, "completed");
        temp1["Notcompleted"] = getResponseOverall(getMetaRespondantDetailsData && getMetaRespondantDetailsData[0] ? getMetaRespondantDetailsData[0] : {}, "notcompleted");
        temp1["ResponseRate"] = getResponseValue(getMetaRespondantDetailsData && getMetaRespondantDetailsData[0] ? getMetaRespondantDetailsData[0] : {}, "responserate").toString() + "%";


        let showNew = "";
        if (this.state.showValue) {
            showNew = this.state.showValue;
        } else {
            if (FilterLevelData && FilterLevelData.length > 0) {
                showNew = FilterLevelData[0]["name"]
            }
        }
        let clientData = this.props.dashboard.ClientProfileData;



        let listData = getResponseAnalyticsPaginationData
        let listTotal = getResponseAnalyticsPaginationTotal;


        let EmployeeList = [];

        if (filterformData.showAll) {
            EmployeeList = listData;
        }
        else {
            if (listData && listData.length > 0) {
                listData.forEach((tempdata) => {

                    if (filterformData.isMailSent === 0 && filterformData.isMailSent === 0 && filterformData.isMailSent === 0) {

                    }

                    if (
                        (filterformData.isMailSent === 0 ? true : (filterformData.isMailSent === 1 ? (tempdata.isMailSent === true) : (filterformData.isMailSent === 2 ? (tempdata.isMailSent === false) : false)))
                        &&
                        (filterformData.isClicked === 0 ? true : (filterformData.isClicked === 1 ? (tempdata.isClicked === true) : (filterformData.isClicked === 2 ? (tempdata.isClicked === false) : false)))
                        &&
                        (filterformData.isComplete === 0 ? true : (filterformData.isComplete === 1 ? (tempdata.isComplete === true) : (filterformData.isComplete === 2 ? (tempdata.isComplete === false) : false)))
                    ) {
                        EmployeeList.push(tempdata)
                    }
                })
            }
        }



        let DownloadExcelResponse = [temp1];
        if (getMetaResponseAnalyticsFilterData && getMetaResponseAnalyticsFilterData.length > 0) {
            getMetaResponseAnalyticsFilterData.forEach((element) => {

                let temp = {}


                temp[CurrentFilterName] = element && element.name ? element.name : "NA";
                temp["Sent"] = getResponseValue(element.data, "mailSent");
                temp["Clicked"] = getResponseValue(element.data, "clicked");
                temp["Notclicked"] = getResponseValue(element.data, "notclicked");
                temp["Completed"] = getResponseValue(element.data, "completed");
                temp["Notcompleted"] = getResponseValue(element.data, "notcompleted");
                temp["ResponseRate"] = getResponseValue(element.data, "responserate").toString() + "%";


                DownloadExcelResponse.push(temp)
            })
        }



        
        let DownloadExcelResponseV2 = [];
        if (EmployeeList && EmployeeList.length > 0) {
            EmployeeList.forEach((element) => {
                console.log("element---->", element)

                let temp = {}
                temp["Name"] = element && element.employeeId && element.employeeId.name ? element.employeeId.name : "NA";
                temp["Emp ID"] = element && element.employeeId && element.employeeId.emp_id ? element.employeeId.emp_id : "NA";
                temp["Sent"] = element && element.isMailSent?"YES":"NO";
                temp["Clicked"] = element && element.isClicked?"YES":"NO";
                temp["Completed"] = element && element.isComplete?"YES":"NO";

                DownloadExcelResponseV2.push(temp)
            })
        }



        


        console.log("DownloadExcelResponseV2---->", DownloadExcelResponseV2)
        console.log("listData---->", listData)
        console.log("listTotal---->", listTotal)
        console.log("EmployeeList---->", EmployeeList)

        let LanguageObj = {};
        let CurrentLanguage = "en";



        let isMailList = [
            {
                id: 0,
                type: 'Deliver Status'
            },
            {
                id: 1,
                type: LanguageObj && LanguageObj["delivered_" + CurrentLanguage] ? LanguageObj["delivered_" + CurrentLanguage] : "Delivered"
            },
            {
                id: 2,
                type: LanguageObj && LanguageObj["not_delivered_" + CurrentLanguage] ? LanguageObj["not_delivered_" + CurrentLanguage] : "Not Delivered"
            }
        ]

        let isClickedList = [
            {
                id: 0,
                type: 'Click Status'
            },
            {
                id: 1,
                type: LanguageObj && LanguageObj["clicked_" + CurrentLanguage] ? LanguageObj["clicked_" + CurrentLanguage] : "Clicked",
            },
            {
                id: 2,
                type: LanguageObj && LanguageObj["not_clicked_" + CurrentLanguage] ? LanguageObj["not_clicked_" + CurrentLanguage] : "Not Clicked"
            }
        ]

        let isCompleteList = [
            {
                id: 0,
                type: 'Complete Status'
            },
            {
                id: 1,
                type: LanguageObj && LanguageObj["completed_" + CurrentLanguage] ? LanguageObj["completed_" + CurrentLanguage] : "Completed"
            },
            {
                id: 2,
                type: LanguageObj && LanguageObj["not_completed_" + CurrentLanguage] ? LanguageObj["not_completed_" + CurrentLanguage] : "Not Completed"
            }
        ]


        function getPageValue(type, campaignEmpPageNo, campaignEmpSize, listTotal) {
            let value1 = (((campaignEmpPageNo - 1) * campaignEmpSize)) + 1
            let value2 = (((campaignEmpPageNo - 1) * campaignEmpSize)) + 1 + (campaignEmpSize - 1)
            let value3 = listTotal ? listTotal : 0;

            if (type === 1) {
                return value1
            } else if (type === 2) {
                return (value3 < value2) ? value3 : value2
            } else {
                return value3
            }

        }

        let surveyName = "";
        let ClientSurvey = clientData && clientData.survey ? clientData.survey : {}
        if (ClientSurvey && ClientSurvey.name) {
            surveyName = ClientSurvey.name;
        }



        return (
            <>

                <LoadingOverlay
                    active={loading}
                    // active={false}

                    spinner
                    text='Loading Data...'
                    className="loader"
                >
                    <div className='h-screen overflow-hidden bg-gray-50'>

                        <Header
                            ClientProfileData={clientData}
                            props={this.props}
                            sidebarToggle={{}}
                            CurrentSurveyCode={this.state.CurrentSurveyCode}
                        />

                        <div className=" w-full overflow-y" style={{ height: 'calc(100% - 2rem)' }}>




                            <main className="flex-1 w-full overflow-hidden overflow-y-auto  h-[calc(100vh-4rem)] bg-[#F9FAFB]">


                                <div className='p-6 space-y-6'>

                                    <div className="">
                                        <div className="space-y-4" style={{}}>

                                            <div className='flex items-center space-x-4'>
                                                <h1 className="xl:text-2xl text-xl font-medium text-[#3D405B]">{surveyName}</h1>
                                            </div>


                                            <div className="grid gap-6 lg:grid-cols-3 md:grid-cols-3 ">
                                                <ResponseCards getRespondantDetailsData={getMetaRespondantDetailsData} />
                                            </div>

                                            <div className="mt-4 capitalize bg-white border rounded-md">
                                                <div className="px-4">
                                                    <div className="py-4 space-y-4 ">

                                                        <div className="flex flex-wrap items-center justify-between gap-4 pb-2">

                                                            <div className="flex items-center w-full space-x-2 overflow-x-auto border-b whitespace-nowrap">

                                                                <h1
                                                                    onClick={() => this.handleResponseType(1)}
                                                                    className={
                                                                        responseType === 1
                                                                            ? "cursor-pointer text-sm py-2 px-4 font-medium bg-gradient-to-l from-[#62cff4]  to-[#2c67f2] text-white rounded-t-md border border-[#2196f3] "
                                                                            : "cursor-pointer text-sm py-2 px-4 font-medium bg-[#fff] text-slate-600   rounded-t-md border"
                                                                    }
                                                                >
                                                                    {"Response Status Analytics"}
                                                                </h1>

                                                                <h1
                                                                    onClick={() => this.handleResponseType(2)}
                                                                    className={
                                                                        responseType === 2
                                                                            ? "cursor-pointer text-sm py-2 px-4 font-medium bg-gradient-to-l from-[#62cff4]  to-[#2c67f2] text-white rounded-t-md border border-[#2196f3] "
                                                                            : "cursor-pointer text-sm py-2 px-4 font-medium bg-[#fff] text-slate-600   rounded-t-md border  "
                                                                    }
                                                                >
                                                                    {"Response Demographic Wise"}
                                                                </h1>

                                                            </div>




                                                        </div>


                                                    </div>


                                                </div>



                                                {responseType === 1 ?
                                                    <div className="capitalize bg-white">
                                                        <div className="px-4">
                                                            <div className="py-4 space-y-4 ">

                                                                <div className="flex flex-wrap items-center justify-between gap-4 pb-2">
                                                                    <div className='flex justify-between w-full space-x-2 itmes-center md:w-auto md:justify-start md:space-x-4 '>
                                                                        <div className='flex items-center space-x-2'>
                                                                            <div className="flex items-center px-2 text-sm md:text-xl">{"Response Status Analytics"} </div>
                                                                        </div>
                                                                    </div>



                                                                    <div className='flex justify-between w-full space-x-2 itmes-center md:w-auto md:justify-start md:space-x-4 '>

                                                                        <div className=''>
                                                                            <button onClick={() => this.RefreshAPI()}
                                                                                className=" bg-[#2196f3] p-2 px-4 rounded-md border text-[#fff] group  hover:text-[#fff] transition-all duration-150  cursor-pointer text-sm flex items-center font-medium space-x-2">
                                                                                <svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-refresh" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
                                                                                    <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                                                                                    <path d="M20 11a8.1 8.1 0 0 0 -15.5 -2m-.5 -4v4h4"></path>
                                                                                    <path d="M4 13a8.1 8.1 0 0 0 15.5 2m.5 4v-4h-4"></path>
                                                                                </svg>
                                                                                <span>{"Refresh"}</span>
                                                                            </button>
                                                                        </div>

                                                                        {/* 
                                                                        <div className='mx-2'>
                                                                            <button onClick={() => this.handleExportModal(!this.state.showExportModal)} className=" bg-white p-2 px-4 rounded-md border text-[#3D405B] group  hover:text-[#2196f3] transition-all duration-150  cursor-pointer text-sm flex items-center font-medium space-x-2">
                                                                                <svg xmlns="http://www.w3.org/2000/svg" className="group-hover:text-[#2196f3] transition-all duration-150  text-[#3D405B] icon icon-tabler icon-tabler-file-x" width="24" height="24" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round"
                                                                                > <path stroke="none" d="M0 0h24v24H0z" fill="none" /> <path d="M14 3v4a1 1 0 0 0 1 1h4" /> <path d="M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z" /> <path d="M10 12l4 4m0 -4l-4 4" />
                                                                                </svg>
                                                                                <span>{"Download Excel"}</span>
                                                                            </button>
                                                                        </div> */}


                                                                        <div className='mx-2'>
                                                                            {DownloadExcelResponseV2 && DownloadExcelResponseV2.length > 0 ?
                                                                                <CSVLink data={DownloadExcelResponseV2} filename={"ResponseStatusAnalytics"}>
                                                                                    <div className='mx-2'>
                                                                                        <button onClick={() => this.handleExportModal(!this.state.showExportModal)} className=" bg-white p-2 px-4 rounded-md border text-[#3D405B] group  hover:text-[#2196f3] transition-all duration-150  cursor-pointer text-sm flex items-center font-medium space-x-2">
                                                                                            <svg xmlns="http://www.w3.org/2000/svg" className="group-hover:text-[#2196f3] transition-all duration-150  text-[#3D405B] icon icon-tabler icon-tabler-file-x" width="24" height="24" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round"
                                                                                            > <path stroke="none" d="M0 0h24v24H0z" fill="none" /> <path d="M14 3v4a1 1 0 0 0 1 1h4" /> <path d="M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z" /> <path d="M10 12l4 4m0 -4l-4 4" />
                                                                                            </svg>
                                                                                            <span>{"Download Excel"}</span>
                                                                                        </button>
                                                                                    </div>
                                                                                </CSVLink>
                                                                                : '...'}
                                                                        </div>





                                                                    </div>

                                                                </div>


                                                                <div className='w-full overflow-x-auto md:whitespace-normal whitespace-nowrap'>
                                                                    <table className="w-full border-collapse">
                                                                        <thead>
                                                                            <tr className="text-sm">
                                                                                <th className="p-3 font-semibold text-gray-800 border border-gray-300 bg-gray-50">S/N</th>

                                                                                {selectFilterType === 1 ?
                                                                                    <th className="p-3 font-semibold text-gray-800 border border-gray-300 bg-gray-50">{LanguageObj && LanguageObj["email_address_label_" + CurrentLanguage] ? LanguageObj["email_address_label_" + CurrentLanguage] : "Email Address"}</th>
                                                                                    :
                                                                                    <th className="p-1 font-semibold text-gray-800 border border-gray-300 bg-gray-50">
                                                                                        <span className='flex items-center justify-between'>
                                                                                            <input className="w-full p-2 bg-white focus:outline-none" placeholder={LanguageObj && LanguageObj["search_by_email_text_" + CurrentLanguage] ? LanguageObj["search_by_email_text_" + CurrentLanguage] : "Search email..."} value={surveyReportEmail} onChange={(e) => this.handleEmailInput(e.target.value)} />
                                                                                            <span onClick={() => this.handleEmailSearchInput()} className="mx-1 mt-1 cursor-pointer material-symbols-outlined">search</span>
                                                                                        </span>
                                                                                    </th>}

                                                                                {selectFilterType === 1 ?
                                                                                    <th className="p-3 font-semibold text-gray-800 border border-gray-300 bg-gray-50">{LanguageObj && LanguageObj["delivered_" + CurrentLanguage] ? LanguageObj["delivered_" + CurrentLanguage] : "Delivered"}</th>
                                                                                    :
                                                                                    <th className="p-1 font-semibold text-gray-800 border border-gray-300 bg-gray-50">
                                                                                        <div onClick={() => this.HandleFilterType(2)} className="block mx-1 bg-white border xl:block lg:block md:block">
                                                                                            <select onChange={(event) => this.handleIsMailSent(event.target.value)} className="w-full py-1 pl-2 text-xs font-normal outline-none text-slate-800">
                                                                                                {isMailList && isMailList.length > 0 ?
                                                                                                    isMailList.map((item) =>
                                                                                                        <option value={item.id} className="text-xs">{item.type}</option>
                                                                                                    )
                                                                                                    : null}
                                                                                            </select>
                                                                                        </div>
                                                                                    </th>}


                                                                                {selectFilterType === 1 ?
                                                                                    <th className="p-3 font-semibold text-gray-800 border border-gray-300 bg-gray-50">{LanguageObj && LanguageObj["clicked_" + CurrentLanguage] ? LanguageObj["clicked_" + CurrentLanguage] : "Clicked"}</th>
                                                                                    :
                                                                                    <th className="p-1 font-semibold text-gray-800 border border-gray-300 bg-gray-50">
                                                                                        <div onClick={() => this.HandleFilterType(3)} className="block mx-1 bg-white border xl:block lg:block md:block">
                                                                                            <select onChange={(event) => this.handleIsClicked(event.target.value)} className="w-full py-1 pl-2 text-xs font-normal outline-none text-slate-800">
                                                                                                {isClickedList && isClickedList.length > 0 ?
                                                                                                    isClickedList.map((item) =>
                                                                                                        <option value={item.id} className="text-xs">{item.type}</option>
                                                                                                    )
                                                                                                    : null}
                                                                                            </select>
                                                                                        </div>
                                                                                    </th>}

                                                                                {selectFilterType === 1 ?
                                                                                    <th className="p-3 font-semibold text-gray-800 border border-gray-300 bg-gray-50">{LanguageObj && LanguageObj["completed_" + CurrentLanguage] ? LanguageObj["completed_" + CurrentLanguage] : "Completed"}</th>
                                                                                    :
                                                                                    <th className="p-1 font-semibold text-gray-800 border border-gray-300 bg-gray-50">
                                                                                        <div onClick={() => this.HandleFilterType(4)} className="block mx-1 bg-white border xl:block lg:block md:block">
                                                                                            <select onChange={(event) => this.handleIsComplete(event.target.value)} className="w-full py-1 pl-2 text-xs font-normal outline-none text-slate-800">
                                                                                                {isCompleteList && isCompleteList.length > 0 ?
                                                                                                    isCompleteList.map((item) =>
                                                                                                        <option value={item.id} className="text-xs">{item.type}</option>
                                                                                                    )
                                                                                                    : null}
                                                                                            </select>
                                                                                        </div>
                                                                                    </th>}


                                                                            </tr>
                                                                        </thead>
                                                                        <tbody>

                                                                            {EmployeeList && EmployeeList.length > 0 ?
                                                                                EmployeeList.map((tempdata, index) =>
                                                                                    <>
                                                                                        <EmployeeTableRows campaignEmpPageNo={(this.state.campaignEmpPageNo - 1) * this.state.campaignEmpSize} LanguageObj={LanguageObj} CurrentLanguage={CurrentLanguage} tempdata={tempdata} index={index} forceMail={this.forceMail} resendCampain={this.resendCampain} />

                                                                                    </>
                                                                                )
                                                                                :
                                                                                <tr className="my-10 text-sm text-center text-gray-800 bg-white border lg:mb-0">
                                                                                    <td colSpan="6" className='py-3'>Data not found</td>
                                                                                </tr>
                                                                            }
                                                                        </tbody>
                                                                    </table>

                                                                </div>

                                                                {!surveyReportEmail ?
                                                                    <>

                                                                        <div className="flex items-center justify-center w-full h-16 bg-white ">
                                                                            <div class="flex flex-wrap border divide-x rounded-md ">
                                                                                <button

                                                                                    onClick={() => this.handlePaginaton("prev")}
                                                                                    class="p-4 py-2 text-[#3D405B]/50 hover:bg-[#F9FAFB] hover:text-[#2196F3] transition">
                                                                                    Prev
                                                                                </button>

                                                                                {getPageValue(3, this.state.campaignEmpPageNo, this.state.campaignEmpSize, listTotal) ? (
                                                                                    <>
                                                                                        <button class="p-4 py-2 hover:bg-[#F9FAFB] hover:text-[#2196F3] transition text-[#2196f3] flex">
                                                                                            {getPageValue(1, this.state.campaignEmpPageNo, this.state.campaignEmpSize, listTotal)}
                                                                                            {" - "}
                                                                                            {getPageValue(2, this.state.campaignEmpPageNo, this.state.campaignEmpSize, listTotal)}
                                                                                            <p className='text-[#3D405B]/50 pl-2'>{" of "}{getPageValue(3, this.state.campaignEmpPageNo, this.state.campaignEmpSize, listTotal)}</p>
                                                                                        </button>

                                                                                    </>
                                                                                ) : (
                                                                                    <button class="p-4 py-2 hover:bg-[#F9FAFB] hover:text-[#2196F3] transition text-[#2196f3] flex">
                                                                                        <p className='text-[#3D405B]/50 pl-2'>{0}</p>
                                                                                    </button>
                                                                                )}

                                                                                <button
                                                                                    onClick={() => this.handlePaginaton("next", getPageValue(3, this.state.campaignEmpPageNo, this.state.campaignEmpSize, listTotal))}
                                                                                    class="p-4 py-2 text-[#2196F3] hover:bg-[#F9FAFB] hover:text-[#2196F3] transition">
                                                                                    Next
                                                                                </button>
                                                                            </div>

                                                                        </div>


                                                                    </>
                                                                    : null}

                                                            </div>


                                                        </div>

                                                    </div>
                                                    : null}


                                                {responseType === 2 ?
                                                    <div className="capitalize bg-white">

                                                        <div className='flex items-center justify-between pt-4 mx-3'>
                                                            <div className='flex items-center space-x-2'>
                                                                <div className="flex items-center px-2 text-sm md:text-xl">
                                                                    {"Response Demographic Wise"} </div></div>


                                                            <div className='flex justify-between w-full space-x-2 itmes-center md:w-auto md:justify-start md:space-x-4 '>

                                                                <div className=''>
                                                                    <button onClick={() => this.RefreshDMG()}
                                                                        className=" bg-[#2196f3] p-2 px-4 rounded-md border text-[#fff] group  hover:text-[#fff] transition-all duration-150  cursor-pointer text-sm flex items-center font-medium space-x-2">
                                                                        <svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-refresh" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
                                                                            <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                                                                            <path d="M20 11a8.1 8.1 0 0 0 -15.5 -2m-.5 -4v4h4"></path>
                                                                            <path d="M4 13a8.1 8.1 0 0 0 15.5 2m.5 4v-4h-4"></path>
                                                                        </svg>
                                                                        <span>{"Refresh"}</span>
                                                                    </button>
                                                                </div>


                                                                <FilterDMG
                                                                    showFilter={this.state.showFilter}
                                                                    showValue={showNew}
                                                                    EmpFilterData2={FilterLevelData}
                                                                    DemographicValueList2={getIndexByFilterDMGData}
                                                                    closeFilter={this.closeFilter}
                                                                    handleMultifilterIndexScore={this.handleMultifilterIndexScore2}
                                                                />

                                                                <div className='mx-2'>
                                                                    {DownloadExcelResponse && DownloadExcelResponse.length > 0 ?
                                                                        <CSVLink data={DownloadExcelResponse} filename={"ResponseDemographicWise.csv"}>
                                                                            <button className=" bg-white p-2 px-4 rounded-md border text-[#3D405B] group  hover:text-[#2196f3] transition-all duration-150  cursor-pointer text-sm flex items-center font-medium space-x-2">
                                                                                <svg xmlns="http://www.w3.org/2000/svg" className="group-hover:text-[#2196f3] transition-all duration-150  text-[#3D405B] icon icon-tabler icon-tabler-file-x" width="24" height="24" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round"
                                                                                > <path stroke="none" d="M0 0h24v24H0z" fill="none" /> <path d="M14 3v4a1 1 0 0 0 1 1h4" /> <path d="M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z" /> <path d="M10 12l4 4m0 -4l-4 4" />
                                                                                </svg>
                                                                                <span>Download Excel</span>
                                                                            </button>
                                                                        </CSVLink>
                                                                        : '...'}
                                                                </div>
                                                            </div>


                                                        </div>


                                                        {getMetaResponseAnalyticsFilterData && getMetaResponseAnalyticsFilterData.length > 0 ?

                                                            <ResponseMetaTable
                                                                getResponseOverall={getResponseOverall}
                                                                getResponseValue={getResponseValue}
                                                                litsXAxis={currFilterName}
                                                                getMetaRespondantDetailsData={getMetaRespondantDetailsData}
                                                                getMetaResponseAnalyticsFilterData={getMetaResponseAnalyticsFilterData}
                                                            />
                                                            : <>
                                                                <div className="w-full mb-4 overflow-hidden overflow-x-auto bg-white whitespace-nowrap">
                                                                    {loading ? <div>
                                                                        <div className='py-12 text-lg text-center text-gray-500'>Loading...</div>
                                                                    </div> :
                                                                        <div className='py-12 text-lg text-center text-gray-500'>Data not available</div>
                                                                    }
                                                                </div>
                                                            </>}
                                                    </div>
                                                    : null}



                                            </div>








                                        </div>

                                    </div>

                                </div>

                            </main>


                        </div>
                    </div>
                </LoadingOverlay>
            </>
        );
    }
}

function EmployeeTableRows(props) {

    let { tempdata, index, forceMail, LanguageObj, CurrentLanguage, campaignEmpPageNo, isAssessment } = props;
    return (
        <tr className="mb-10 text-xs text-center text-gray-800 bg-white lg:mb-0">
            <td className="p-3 border border-b ">
                {campaignEmpPageNo + index + 1}
            </td>
            <td className="p-3 border border-b">
                {tempdata.employeeId && tempdata.employeeId.email ? tempdata.employeeId.email : '-'}
            </td>
            <td className="p-3 border border-b">
                {tempdata.isMailSent ?
                    // <div className="p-1 bg-gray-200 border rounded cursor-default">{LanguageObj && LanguageObj["yes_"+CurrentLanguage]? LanguageObj["yes_"+CurrentLanguage]:"Yes"}</div>
                    <span className="px-3 py-1 text-blue-500">{LanguageObj && LanguageObj["yes_" + CurrentLanguage] ? LanguageObj["yes_" + CurrentLanguage] : "Yes"}</span>
                    :
                    // onClick={()=>resendCampain(tempdata.id)} 
                    <span className="px-3 py-1 text-red-500">{LanguageObj && LanguageObj["no_" + CurrentLanguage] ? LanguageObj["no_" + CurrentLanguage] : "No"}</span>
                }
            </td>

            <td className="p-3 border border-b">
                <span className="px-3 py-1">{tempdata.isClicked ? moment.unix(tempdata.clickedDate / 1000).format("DD/MM/YYYY, HH:mm") : 'No'}</span>
            </td>
            <td className="p-3 border border-b">
                <span className="px-3 py-1 ">{tempdata.isComplete ? moment.unix(tempdata.completeDate / 1000).format("DD/MM/YYYY, HH:mm") : 'No'}</span>
            </td>




        </tr>


    )
}



function mapStateToProps(state) {
    ////console.log("state  ", state);
    const { loggingIn } = state.authentication;
    const { survey, dashboard } = state;
    return {
        loggingIn,
        survey,
        dashboard
    };
}
export default connect(mapStateToProps)(SurveyReport);
